import { render, staticRenderFns } from "./QuestionMultipleFreeTextVueComponent.vue?vue&type=template&id=8c8d0c20&"
import script from "./QuestionMultipleFreeTextVueComponent.vue?vue&type=script&lang=ts&"
export * from "./QuestionMultipleFreeTextVueComponent.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionMultipleFreeTextVueComponent.vue?vue&type=style&index=0&id=8c8d0c20&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports